class RuleResult {
  constructor() {}
  // 禁止某进程启动  不关系父进程则null
  procStartFn(parentPath, selfPath, action, matchProc, childNum) {
    if (childNum == '') {
      childNum = 0;
    }
    let msg = '';
    if (matchProc) {
      msg = `ProcStartLevel[Parent(${parentPath})][Self(${selfPath})][Level(${childNum})]=${action}\n`;
    } else {
      msg = `ProcStart[Parent(${parentPath})][Self(${selfPath})]=${action}\n`;
    }
    return msg;
  }
  // 注入拦截(block)与检测（record）
  ProcStartIntercept(parentPath, selfPath, action) {
    let msg = '';
    msg = `Protect[Action(${action})][SrcProc(${parentPath})][TarProc(${selfPath})]=Deny\n`;
    return msg;
  }
  // 放行父进程创建的某子进程，其他进程全部拦截
  procStartOneFn(parentPath, selfPath, matchProc, childNum, selfPath2) {
    let msg = '';
    if (childNum == '') {
      childNum = 0;
    }
    // if(matchProc){
    //   msg = `ProcStartLevel[Parent(${parentPath})][Self(${selfPath})][Level(${childNum})]=Access\nProcStartLevel[Parent(${parentPath})][Self(Path="*\\*.exe")][Level(${childNum})]=Deny\n`
    // }else{

    // }
    msg = `ProcStart[Parent(${parentPath})][Self(${selfPath})]=Access\nProcStart[Parent(${parentPath})][Self(Path="${selfPath2}")]=Deny\n`;
    return msg;
  }
  // 进程循环查杀
  KillProc(path, time) {
    if (time != '') {
      return `KillProc[Self(${path})][Time(${time})]=Access\n`;
    } else {
      return `KillProc[Self(${path})]=Access\n`;
    }
  }
  // 监控某进程，当进程退出就重启计算器 action： RunAgain  Restart
  ProcDied(path, msg, action) {
    return `ProcDied[Self(${path})][Action(${action})][Message(${msg})]=Access\n`;
  }
  // 主动启动进程 probability进程启动概率
  RunProcess(path, probability, time) {
    return `RunProcess[Self(${path})][Probability(${probability})][TimeQuantum(${time})]=Access\n`;
  }
  // 进程保护,任何进程都不能结束path,只有进程pathA才能结束path
  Protect(path, pathA) {
    return `Protect[SrcProc(null)][TarProc(${path})]=Deny\nProtect[SrcProc(${pathA})][TarProc(${path})]=Access\n`;
  }

  // 模块规则
  // 拦截某进程调用某驱动
  Module(path, model, matchProc, childNum) {
    let msg = '';
    if (matchProc) {
      if (childNum == '') {
        childNum = 0;
      }
      msg = `ModuleLevel[Parent(${path})][Self(${model})][Level(${childNum})]=Deny\n`;
    } else {
      msg = `Module[Parent(${path})][Self(${model})]=Deny\n`;
    }
    return msg;
  }
  // 拦截所有驱动近放行
  ModuleOne2(path, model, matchProc, childNum) {
    let msg = '';
    // if(matchProc){
    //   if (childNum == ''){
    //     childNum = 0
    //   }
    //   msg = `ModuleLevel[Parent(null)][Self(Path="*\\*.sys")][Level(${childNum})]=Deny\nModuleLevel[Parent(${path})][Self(${model})][Level(${childNum})]=Access\n`
    // }else{
    //   msg =  `Module[Parent(null)][Self(Path="*\\*.sys")]=Deny\nModule[Parent(${path})][Self(${model})]=Access\n`
    // }
    msg = `Module[Parent(${path})][Self(Path="*\\*.sys")]=Deny\nModule[Parent(${path})][Self(${model})]=Access\n`;
    return msg;
  }
  // 拦截所有驱动近放行
  ModuleOne(path, model, matchProc, childNum) {
    let msg = '';
    // if(matchProc){
    //   if (childNum == ''){
    //     childNum = 0
    //   }
    //   msg = `ModuleLevel[Parent(null)][Self(Path="*\\*.sys")][Level(${childNum})]=Deny\nModuleLevel[Parent(${path})][Self(${model})][Level(${childNum})]=Access\n`
    // }else{
    //   msg =  `Module[Parent(null)][Self(Path="*\\*.sys")]=Deny\nModule[Parent(${path})][Self(${model})]=Access\n`
    // }
    msg = `Module[Parent(${path})][Self(Path="*\\*.dll")]=Deny\nModule[Parent(${path})][Self(${model})]=Access\n`;
    return msg;
  }
  // 文件规则 action:create,read,write,delete,rename,
  FileCheck(path, model, action, matchProc, childNum) {
    let msg = '';
    if (matchProc) {
      if (childNum == '') {
        childNum = 0;
      }
      msg = `FileCheckLevel[Self(${path})][Process(${model})][AccessMode(${action})][Level(${childNum})]=Deny\n`;
    } else {
      msg = `FileCheck[Self(${path})][Process(${model})][AccessMode(${action})]=Deny\n`;
    }
    return msg;
  }
  // 拦截所有仅放行某个进程
  FileCheckOne(path, model, action, matchProc, childNum, selfPath2) {
    let msg = '';
    // if(matchProc){
    //   if (childNum == ''){
    //     childNum = 0
    //   }
    //   msg =  `FileCheckLevel[Self(Path="*.exe")][Process(${model})][AccessMode(${action})][Level(${childNum})]=Deny\nFileAccess[Self(${path})][Process(${model})][AccessMode(${action})]=Access\n`
    // }else{
    //   msg =  `FileCheck[Self(Path="*.exe")][Process(${model})][AccessMode(${action})]=Deny\nFileAccess[Self(${path})][Process(${model})][AccessMode(${action})]=Access\n`
    // }
    if (model == null) {
      msg = `FileCheck[Self(Path="${selfPath2}")][Process(Path="*.exe")][AccessMode(${action})]=Deny\nFileAccess[Self(${path})][Process(Path="*.exe")][AccessMode(${action})]=Access\n`;
    } else {
      msg = `FileCheck[Self(Path="${selfPath2}")][Process(${model})][AccessMode(${action})]=Deny\nFileAccess[Self(${path})][Process(${model})][AccessMode(${action})]=Access\n`;
    }

    return msg;
  }
  // ThreadFileCheck文件操作线程被挂起
  ThreadFileCheck(path, model, action) {
    return `ThreadFileCheck[Self(${path})][Process(${model})][AccessMode(${action})]=Deny\n`;
  }
  SpecFileHide(path, model) {
    return `SpecFileHide[Self(${path})][Process(${model})]=Deny`;
  }

  // 文件隐藏
  // 注册表操作RegCheck[RegPath(null)][Process(Path="*\reg.exe")][AccessMode(All)]=Deny
  RegCheck(path, model, action, matchProc, childNum) {
    let msg = '';
    if (matchProc) {
      if (childNum == '') {
        childNum = 0;
      }
      msg = `RegCheckLevel[RegPath(${path})][Process(${model})][AccessMode(${action})][Level(${childNum})]=Deny\n`;
    } else {
      msg = `RegCheck[RegPath(${path})][Process(${model})][AccessMode(${action})]=Deny\n`;
    }
    return msg;
  }
  // 驱动回调
  CallBack(path, model, action) {
    return `CallBack[Type(${path})][Feature(${model})][Action(${action})]=Access\n`;
  }
  // 网络规则
  NetWork(fileAction, parentProVal, ipVal, portVal, matchProc, childNum) {
    let msg = '';
    if (matchProc) {
      if (childNum == '') {
        childNum = 0;
      }
      msg = `NetWorkLevel[Protocol(${fileAction})][Process(${parentProVal})][Address("*:*->${ipVal}:${portVal}")][Level(${childNum})]=Deny\n`;
    } else {
      msg = `NetWork[Protocol(${fileAction})][Process(${parentProVal})][Address("*:*->${ipVal}:${portVal}")]=Deny\n`;
    }
    return msg;
  }
  // 网络规则2
  NetWorkOne(fileAction, parentProVal, ipVal, portVal, matchProc, childNum) {
    let msg = '';
    if (parentProVal == null) {
      msg = `NetWork[Protocol(${fileAction})][Process(null)][Address("*:*->*:*")]=Deny\nNetWork[Protocol(${fileAction})][Process(null)][Address("${ipVal}:${portVal}")]=Access\n`;
    } else {
      msg = `NetWork[Protocol(${fileAction})][Process(${parentProVal})][Address("*:*->*:*")]=Deny\nNetWork[Protocol(${fileAction})][Process(${parentProVal})][Address("${ipVal}:${portVal}")]=Access\n`;
    }
    return msg;
  }
  // 窗口规则
  WindowCheck(parentProVal, title, classs, style, rect, action) {
    return `WindowCheck[Self(${parentProVal})][Title(${title})][Class(${classs})][Style(${style})][Rect(${rect})][Action(${action})]=Deny\n`;
  }
  // 线程规则
  ThreadControl(parentPath, selfPath, Delay, Offset, action, index, matchProc, childNum) {
    let msg = '';
    if (childNum == '' || childNum == null) {
      childNum = 0;
    }
    if (matchProc) {
      console.log(childNum);
      let childNum2 = 0;
      if (childNum == '') {
        childNum2 = 0;
      } else {
        childNum2 = childNum;
      }
      if (Delay != '') {
        msg = `ThreadControl[Delay(s=${Delay})][Exe(${parentPath})][Dll(${selfPath})][Offset(${Offset})][Action(${action})][Index(${index})][Level(${childNum2})]=Deny\n`;
      } else {
        msg = `ThreadControl[Exe(${parentPath})][Dll(${selfPath})][Offset(${Offset})][Action(${action})][Index(${index})][Level(${childNum2})]=Deny\n`;
      }
    } else {
      if (Delay != '') {
        msg = `ThreadControl[Delay(s=${Delay})][Exe(${parentPath})][Dll(${selfPath})][Offset(${Offset})][Action(${action})][Index(${index})]=Deny\n`;
      } else {
        msg = `ThreadControl[Exe(${parentPath})][Dll(${selfPath})][Offset(${Offset})][Action(${action})][Index(${index})]=Deny\n`;
      }
    }

    return msg;
  }
}

export default new RuleResult();
